"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectConfig = createProjectConfig;
function createProjectConfig(projectConfig) {
    return projectConfig;
}
//# sourceMappingURL=createProjectConfig.js.map